import Vue from 'vue'
import VueRouter from 'vue-router'
import authRoutes from '../apps/auth/routes'
import plantRoutes from '../apps/plant/routes'
import ticketRoutes from '../apps/ticket/routes'
import stakeholderRoutes from '../apps/stakeholder/routes'
import userRoutes from '../apps/user/routes'
import urlRoutes from '../apps/url/routes'
import controlRoutes from '../apps/control/routes'

Vue.use(VueRouter)

const routes = [
  {
    path: '/auth',
    component: () => import(/* webpackChunkName: "apps-auth" */ '@/apps/auth/AuthApp.vue'),
    children: [...authRoutes],
  },
  {
    path: '/plant',
    component: () => import(/* webpackChunkName: "apps-plant" */ '@/apps/plant/PlantApp.vue'),
    children: [...plantRoutes],
  }, 
  {
    path: '/ticket',
    component: () => import(/*webpackChunkName: "apps-ticket" */ '@/apps/ticket/TicketApp.vue'),
    children: [...ticketRoutes],
  },
  {
    path: '/stakeholder',
    component: () => import(/*webpackChunkName: "apps-stakeholder" */ '@/apps/stakeholder/StakeholderApp.vue'),
    children: [...stakeholderRoutes],
  },
  {
    path: '/user',
    component: () => import(/* webpackChunkName: "apps-user" */ '@/apps/user/UserApp.vue'),
    children: [...userRoutes],
  },
  {
    path: '/url',
    component: () => import(/* webpackChunkName: "apps-url" */ '@/apps/url/UrlApp.vue'),
    children: [...urlRoutes],
  },
  {
    path: '/control',
    component: () => import(/* webpackChunkName: "apps-control" */ '@/apps/control/ControlApp.vue'),
    children: [...controlRoutes],
  },
  {
    path: '/',
    redirect: '/auth/reconnect'  // Redirección por defecto
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
